/* eslint-disable */
import { setCaretAtPosition, getCaretPositionAndNode } from "@/components/items/content-editable-input/functions/helpers";


const splitAt = (index, xs) => [xs.slice(0, index), xs.slice(index)]

export function emojis (emoji, input) {
	let info = getCaretPositionAndNode(input),
		comment = splitAt(info.caretPosition, info.node.data)

	info.node.data = comment[0] + emoji + comment[1]

	setCaretAtPosition(info.node, info.caretPosition + 2);
}

function prepareContentToEdit(input) {
	let lastChild = input.lastChild

	if (lastChild && lastChild.tagName === 'BR') input.removeChild(lastChild)

	input.innerHTML = input.innerHTML.replaceAll('&nbsp;', ' ')
	input.innerHTML = input.innerHTML.replaceAll('<br>', '\n')

	return input.innerHTML
}
